export default __webpack_public_path__ + "8719b52b907e43e07801290a30ff71ef.png";